var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "ruleForm",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "故事生成方式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择方式" },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "问答形式", value: "1" } }),
                  _c("el-option", { attrs: { label: "条款形式", value: "2" } }),
                ],
                1
              ),
              _c(
                "el-upload",
                {
                  staticClass: "left",
                  attrs: {
                    action: "#",
                    "auto-upload": false,
                    "on-remove": _vm.handleRemove,
                    "on-change": _vm.handleChange,
                    "file-list": _vm.fileList,
                    accept: "file",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v(" 点击上传(只支持markdown,不支持多选) ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "width50", attrs: { label: "故事", required: "" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入故事" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "width100", attrs: { label: "描述", required: "" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入描述" },
                model: {
                  value: _vm.form.desc,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "desc", $$v)
                  },
                  expression: "form.desc",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "width100 height100",
              attrs: { label: "内容", required: "" },
            },
            [
              _vm.fileList.length
                ? _c("v-md-preview", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.uploadLoading,
                        expression: "uploadLoading",
                      },
                    ],
                    attrs: { text: _vm.form.content },
                  })
                : _c("el-input", {
                    attrs: {
                      id: "textarea",
                      type: "textarea",
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }